import css from 'styles/components/checkout/payment/paymentAsList/paypalInit.scss';

export const PayPalPaymentReview = () => (
  <div className={css.payPalModeSection} id="pay-pal-content" role="tabpanel" aria-labelledby="pay-pal-tab">
    Using your chosen PayPal payment method
  </div>
);

export default PayPalPaymentReview;
